import React from 'react';
import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Tab1 from './Tab1';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import { useNavigate } from 'react-router-dom';
import { ColumnsType } from 'antd/es/table';
import { PrintTransactionCaisseDirect, PrintTransactionListingCaisseDirect } from '../../../../utilitaires/globalFunction';
//import { useAgence } from '../../../AgenceContext';
import { useAgence } from '../../../../AgenceContext';

//import "../../Assets/Styles/StyleForm.css";


const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip; 



//client Physique
const ListingLitigeCaisse = () => {
  // USER SESSION
  const auth = useAuthUser()
   const Branch=useAgence();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [Activetabs, SetActivetabs] = useState(false);
  const [DataLis, SetDataLis] = useState<any[]>([]);
  const [Imprimer, SetImprimer] = useState(true);


  const navigate = useNavigate();

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields()
    form.setFieldValue("niveau", 900)
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    SetActivetabs(false)
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()

    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }

  const column: ColumnsType<any> = [
    {
      title: 'Date Opération',
      dataIndex: 'DATECR'
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
    },
    {
      title: 'Reférence',
      dataIndex: 'REPECE'
    },
    {
      title: 'Sens',
      dataIndex: 'sensec'
    },
    {
      title: 'Montant',
      dataIndex: 'MONTAN'
    },
    {
      title: 'Compte',
      dataIndex: 'NODUCP'
    },
    {
      title: 'NUMRAP',
      dataIndex: 'NUMRAP'
    },
    {
      title: 'Remettant',
      dataIndex: 'REMETT'
    },
    {
      title: 'CNI Remettant',
      dataIndex: 'cniremet'
    },
    {
      title: 'Type opération',
      dataIndex: 'TYPOPE'
    },
    {
      title: 'Saisie par',
      dataIndex: 'UTISAI'
    },
    {
      title: 'Validé par',
      dataIndex: 'UTIVAL'
    }
  ];

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          listing des litiges Caisse
        </span>
      ),
      children: <Tab1 form={form} data={DataLis} />,
    }
  ];

  const onFinish = (values: any) => {
    setLoading(true)

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetListingLitigeCaisse,
      headers: {
        'CypherNODECE': Crypter.encrypt(values.UTISAI),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(values.Agence),
        'CypherOperat': Crypter.encrypt(values.TypeOpe),
        'CypherDatDeb': Crypter.encrypt((new Date(values.DateDebut)).toLocaleDateString("fr").replaceAll('/', '-')),
        'CypherDatF': Crypter.encrypt((new Date(values.DateFin)).toLocaleDateString("fr").replaceAll('/', '-')),
        'CypherOption': Crypter.encrypt('1'),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      }
    };

    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          SetDataLis([]);
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            if (res.Result.length > 0) {
              let newDatas: any[] = [];
              let TotalDebit: number = 0;
              let TotalCrebit: number = 0;
              let NbrCrebit: number = 0;
              let Nbrdebit: number = 0;

              form.setFieldsValue({"TotalCrebit":'',"TotalDebit":'',"NbrCrebit":'',"Nbrdebit":''});

              res.Result.map((data: any, indice: number) => {
                newDatas.push({
                  DATECR: data.DATECR ? (new Date(data.DATECR.substring(0, 10))).toLocaleDateString("fr") : '',
                  REPECE: data.REPECE,
                  MONTAN: formatNumber(data.MONTAN),
                  NODUCP: data.NODUCP,
                  NUMRAP: data.NUMRAP,
                  LIBELL: data.LIBELL,
                  sensec: data.sensec,
                  REMETT: data.REMETT,
                  cniremet: data.cniremet,
                  TYPOPE: data.TYPOPE,
                  UTISAI: data.UTISAI,
                  UTIVAL: data.UTIVAL
                })

                //Incrémentation des Montants Totaux
                if (data.sensec === 'D') { Nbrdebit++; TotalDebit += data.MONTAN }
                else { NbrCrebit++; TotalCrebit += data.MONTAN; }
              })

              // form.setFieldValue("ReportSold", formatNumber(RePorSoldeI));
              form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
              form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
              form.setFieldValue("NbrCrebit", NbrCrebit);
              form.setFieldValue("Nbrdebit", Nbrdebit);

              SetDataLis(newDatas);
              localStorage.removeItem(Data.LocalVariable.tabListcaiss)
              localStorage.setItem(Data.LocalVariable.tabListcaiss, JSON.stringify({ "columns": column, "data": newDatas, "form": form.getFieldsValue() }))
              //tabListcaiss
              SetImprimer(false);
              setLoading(false)
            }
            else SweetAlert.fire({ title: "No Data", text: "Aucun élement retourné", icon: "question" })

          }
          else {
            setLoading(false)
            SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
      });

  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  return (
    <div className='tab'>
      <Box className='formTitle'> <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb
          component="a"
          href="/jjh"
          label="Affichage"
          icon={<HomeIcon fontSize="small" />}
        />
        <StyledBreadcrumb component="a" href="#" label="Transactions" />
        <StyledBreadcrumb
          label="Litige caisse"
          deleteIcon={<ExpandMoreIcon />}
        />
      </Breadcrumbs></Box>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} type="ghost" htmlType="submit" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={Imprimer} 
                onClick={() => { 
                 // navigate("/transaction/brouillardJour/PrintListOpeCait");

                   PrintTransactionListingCaisseDirect(
                                                         user.coduti ?? '',
                                                         user.codage ?? '',
                                                         Branch.agence?.LIBELLE ?? '',
                                                         Branch.agence?.BANQUE ?? '',
                                                         Branch.agence?.TELEPH ?? '',
                                                          Branch.agence?.NUMREG ?? '',
                                                          Branch.agence?.LICENCE ?? '',
                                                          Branch.agence?.NUMREG ?? '',
                                                          Branch.agence?.BPOSTE ?? '',
                                                          Branch.agence?.VILLE ?? '',
                                                         user.nomuti ?? '',
                                                         user.codage ?? '',
                                                         user.coduti,
                                                         form.getFieldValue("DateDebut") ?? '',
                                                         form.getFieldValue("DateFin") ?? '',
                                                         0,
                                                         999999999999,
                                                          form.getFieldValue("TypeOpe") ?? '',
                                                         "PDF"
                                                       )

                 }} className='bt_add' type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                {/* <Button size='large' disabled={Imprimer} onClick={() => { navigate("/transaction/brouillardJour/PrintListOpeCait"); }} className='bt_add' type="ghost" htmlType="button" block  >
                  Aperçu
                </Button> */}
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='large' type="card" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );


}

export default ListingLitigeCaisse;

